import { useTranslation } from 'libs/i18n';
import { DialogProps } from 'libs/ui';
import { DialogWithdrawalAccountFeature } from 'modules/client/common/components/sections/WithdrawalAccountsSection/FormContent/components/DialogWithdrawalAccountFeature';
import { WithdrawalAccountFormType } from 'modules/client/common/forms/withdrawalAccountForm';

import { FooterActions } from '../FooterActions';

import { useEditDialogWithdrawalAccount } from './hooks/useEditDialogWithdrawalAccount';

interface Props extends DialogProps {
  onClose: () => void;
  onSubmit: (value: WithdrawalAccountFormType) => void;
  initialValues: WithdrawalAccountFormType;
  readOnly?: boolean;
}

export const DialogEditWithdrawalAccountFeature = ({
  isOpen,
  onClose,
  onSubmit,
  initialValues,
  readOnly,
}: Props) => {
  const { t } = useTranslation();

  const { countries, countriesLoading } = useEditDialogWithdrawalAccount();

  return (
    <DialogWithdrawalAccountFeature
      countries={countries}
      countriesLoading={countriesLoading}
      footerActions={
        <FooterActions
          submitLabel={t('client.client.withdrawalAccounts.saveButton')}
          onClose={onClose}
        />
      }
      initialValues={initialValues}
      isOpen={isOpen}
      readOnly={readOnly}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
};
